import checkup from './checkup'
import smartSearch from './smart-search'

const ai = {
    checkup: Object.assign(checkup, checkup),
    smartSearch: Object.assign(smartSearch, smartSearch),
}

export default ai